import React from 'react';
import InitializeRouter from './InitializeRouter';
import InitializeApp from './InitializeApp';
import InitializePage from './InitializePage';
import { InitMatomo } from './Matomo';

export const App = props => (
  <InitMatomo>
    <InitializeApp>
      <InitializePage>
        <InitializeRouter {...props} />
      </InitializePage>
    </InitializeApp>
  </InitMatomo>
);
